import React from "react"
import styled from 'styled-components';

const ResultRow = styled.div`
  .results-summary {
    display: inline-block;
    color: #575757;

    .highlight-value {
      color: rgb(48 145 218);
      font-weight: bold;
    }
  }
`;

interface DivWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  // [key: string]: any
}

export class ResultsRow extends React.Component<DivWrapperProps> {
  render() {
    const {children, ...rest} = this.props;
    return <ResultRow {...rest}>
      {children}
    </ResultRow>;
  }
}

export default ResultsRow;
